import React from "react";
import { IInputProps } from "@interfaces";
import { useController } from "react-hook-form";
import {
  Calendar,
  CalendarProps,
  CalendarSelectionMode,
} from "primereact/calendar";

import { Field } from "../../field";

//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.

export interface ICalendarProps<T extends CalendarSelectionMode>
  extends IInputProps,
    Omit<CalendarProps<T>, "name"> {}

const $Calendar = <T extends CalendarSelectionMode>({
  name,
  label,
  rules,
  disabled,
  helperText,
  defaultValue,
  disabledInput,
  fieldClassName,
  shouldUnregister,
  ...props
}: ICalendarProps<T>) => {
  const { field, fieldState } = useController({
    name,
    rules,
    disabled,
    defaultValue,
    shouldUnregister,
  });

  return (
    <Field
      name={name}
      label={label}
      helperText={helperText}
      className={fieldClassName}
      isRequired={!!rules?.required}
    >
      <Calendar
        {...field}
        {...props}
        disabled={disabledInput}
        invalid={fieldState.invalid}
      />
    </Field>
  );
};

export default $Calendar;
